// src/components/Home.js
import React from "react";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import EmployeeManagement from "./EmployeeManagement";

const Home = () => {
  return (
    <>
        <section className="flex">
      <Sidebar />
      <div className="flex-1">
        <Navbar />
        <EmployeeManagement/>
      </div>
    </section>
    </>
  );
};

export default Home;